import { COLLECTION_CATALOG_ITEMS, ITEM_CLICKED_DATA } from './constants';
import { IS_SERVER } from './checkRenderEnv';

/**
 *
 * @returns boolean indicating whether the clicked item's timestamp is within the state refresh period (expiry interval)
 */
export function isTimerExpired() {
  let expired = true;
  if (!IS_SERVER) {
    const sessionData = JSON.parse(sessionStorage?.getItem(ITEM_CLICKED_DATA));
    if (sessionData) {
      const expiresAt = new Date(sessionData.expiresAt);
      const currentTime = new Date();
      expired = currentTime > expiresAt;
    }
  }

  if (expired) {
    sessionStorage.removeItem(COLLECTION_CATALOG_ITEMS);
    sessionStorage.removeItem(ITEM_CLICKED_DATA);
  }
  // If session data doesn't exist or if running in server, consider timer as expired
  return expired;
}
